import coreAPIInstance from "./coreApiInstance";

export const streamsAPIs = {
  streamsValidate: ({ payload }) => coreAPIInstance.post(`/api/v1/streams/validate`, payload),
};
